/**
 * Maps a date to a database input format.
 * The output format is: yyyy-mm-yy
 * @param date string or Date object to be mapped
 */

export const mapDateObjectToString = (date: Date | string): string => {
    const dateObj = typeof date === 'string' ? new Date(date) : date;

    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
};
